import React from "react";
import logo from "../img/pantelogo.svg";

export default function Pantelogo() {
  return (
    <div className="pantelogo">
      <img src={logo} alt="Bærehjelp logo" />
    </div>
  );
}
